<template>
  <header class="tmbHeader" role="banner">
    <!-- ======= CountDown Timer Bar ======= -->
    <section
      :class="['countdown_bar', { countdown_finished: isCountdownFinished }]"
      :style="countdownBarStyle"
      aria-label="Sale countdown timer"
    >
      <div class="t-center big_container countdown_content">
        <p class="countdown_bar_text" :style="countTextColor">
          {{ shopifyData.countdownText }}
        </p>
        <div id="countdown" class="countdown_container" role="timer" aria-live="polite">
          <ul class="countdown_wrapper" aria-label="Time remaining">
            <li :style="countTextColor">
              <span aria-label="Days">{{ days }}</span
              >days
            </li>
            <li class="dots" :style="color" aria-hidden="true">:</li>
            <li :style="countTextColor">
              <span aria-label="Hours">{{ hours }}</span
              >Hrs
            </li>
            <li class="dots" :style="color" aria-hidden="true">:</li>
            <li :style="countTextColor">
              <span aria-label="Minutes">{{ minutes }}</span
              >Mins
            </li>
            <li class="dots" :style="color" aria-hidden="true">:</li>
            <li :style="countTextColor">
              <span aria-label="Seconds">{{ seconds }}</span
              >Secs
            </li>
          </ul>
        </div>
        <a
          class="countdown_btn"
          :href="shopifyData.countBbtnLink"
          :style="countTextColor"
          :aria-label="`Shop now: ${shopifyData.countBtnTitle}`"
        >
          {{ shopifyData.countBtnTitle }}
        </a>
      </div>
    </section>

    <!-- ======= Announcement Bar ======= -->
    <section
      ref="announcementBar"
      class="announcement_bar"
      :style="announcementBarStyle"
      role="complementary"
      aria-label="Announcement"
    >
      <a
        :href="shopifyData.barLink"
        :class="{ link: shopifyData.barLink !== 'blank' }"
        :aria-label="hasBarLink ? 'Click for more details' : undefined"
      >
        <div class="t-center big_container announcement_content">
          <swiper
            v-if="hasMultipleSlides"
            :modules="swiperModules"
            :slides-per-view="1"
            :space-between="20"
            :loop="true"
            :speed="3000"
            :autoplay="{ delay: 3000, disableOnInteraction: false }"
            class="mySwiper"
          >
            <swiper-slide v-for="(item, index) in slider" :key="index">
              <p class="announcement_bar_text" :style="color">
                {{ item }}
              </p>
            </swiper-slide>
          </swiper>
          <p v-else class="announcement_bar_text" :style="color">
            {{ shopifyData.announcementText }}
          </p>
          <button
            ref="closeIcon"
            class="closeIcon"
            type="button"
            aria-label="Close announcement bar"
            @click.prevent="closeAnnouncementBar"
          >
            <svg
              id="Layer_1"
              class="closeSvg"
              style="enable-background: new 0 0 512 512"
              version="1.1"
              viewBox="0 0 512 512"
              xml:space="preserve"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              aria-hidden="true"
              focusable="false"
            >
              <path
                :fill="shopifyData.textColor"
                d="M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"
              />
            </svg>
          </button>
        </div>
      </a>
    </section>

    <div class="tmbHeader_new">
      <div class="productInventory" style="opacity: 0; position: absolute" aria-hidden="true">
        <div v-for="(item, index) in ProductInventoryData" :key="index">
          <p
            class="tmbAvailableDataCart"
            :data-id="item.product.variantId"
            :data-stock="item.product.availableInventory"
          ></p>
        </div>
      </div>

      <!-- ======= Desktop Navigation ======= -->
      <div class="navbar-desktop-wrap">
        <nav class="navbar navbar-desktop" role="navigation" aria-label="Main navigation">
          <!-- Toggle Button -->
          <div class="header_toggle_wrap">
            <button
              ref="headerToggle"
              type="button"
              class="header_toggle"
              aria-label="Toggle mobile menu"
              aria-expanded="false"
              aria-controls="mobile-navigation"
              @click="togleHeader"
            >
              <span class="toggle_bar toggle_bar-top" />
              <span class="toggle_bar toggle_bar-center" />
              <span class="toggle_bar toggle_bar-bottom" />
            </button>
          </div>
          <!-- left Navlist -->
          <ul class="navlist navlist-left">
            <li class="navitem first-navitem">
              <template v-if="HeaderNavData[0]">
                <a
                  :href="HeaderNavData[0].url"
                  class="navlink navlink_drpdown"
                  v-html="HeaderNavData[0].title"
                />
                <template v-if="hasSubLinks(0)">
                  <!--  HANDBAGS & WALLETS Start -->
                  <div
                    class="navlink__hover"
                    role="menu"
                    @mouseenter="stopScroll"
                    @mouseleave="workScroll"
                  >
                    <ul class="navink__hover_list">
                      <li
                        v-for="subLink in HeaderNavData[0].links"
                        :key="subLink.title"
                        class="navlink__hover_item"
                        role="menuitem"
                      >
                        <ul class="subnavlink__list hover-img">
                          <template
                            v-for="(nestedSubLink, nestedSubLinkIndex) in subLink.links"
                            :key="nestedSubLink.title"
                          >
                            <template v-if="!isImageUrl(nestedSubLink.url)">
                              <li class="subnavlink__item">
                                <template
                                  v-if="hasNextImageLink(subLink.links, nestedSubLinkIndex)"
                                >
                                  <a
                                    :href="nestedSubLink.url"
                                    class="subnavlink"
                                    @mouseover="subnavlinkHover"
                                    v-html="nestedSubLink.title"
                                  />
                                  <a :href="nestedSubLink.url" class="subnavlink subnavlink-img">
                                    <img
                                      v-lazy="subLink.links[nestedSubLinkIndex + 1].url"
                                      alt="Product category image"
                                      loading="lazy"
                                      width="130"
                                      height="130"
                                      decoding="async"
                                    />
                                  </a>
                                </template>
                                <template v-else-if="nestedSubLink.url === '#'">
                                  <span
                                    class="subnavlink subnavlink-heading"
                                    v-html="nestedSubLink.title"
                                  />
                                </template>
                                <template v-else>
                                  <a
                                    :href="nestedSubLink.url"
                                    class="subnavlink"
                                    v-html="nestedSubLink.title"
                                  />
                                </template>
                              </li>
                            </template>
                          </template>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <!--  HANDBAGS & WALLETS End -->
                </template>
              </template>
            </li>
            <li class="navitem">
              <template v-if="HeaderNavData[1]">
                <a
                  :href="HeaderNavData[1].url"
                  class="navlink navlink_drpdown"
                  v-html="HeaderNavData[1].title"
                />
                <template v-if="hasSubLinks(1)">
                  <!--  Takat & WALLETS Start -->
                  <div
                    class="navlink__hover"
                    role="menu"
                    @mouseenter="stopScroll"
                    @mouseleave="workScroll"
                  >
                    <ul class="navink__hover_list">
                      <li
                        v-for="subLink in HeaderNavData[1].links"
                        :key="subLink.title"
                        class="navlink__hover_item"
                        role="menuitem"
                      >
                        <ul class="subnavlink__list hover-img">
                          <template
                            v-for="(nestedSubLink, nestedSubLinkIndex) in subLink.links"
                            :key="nestedSubLink.title"
                          >
                            <template v-if="!isImageUrl(nestedSubLink.url)">
                              <li class="subnavlink__item">
                                <template
                                  v-if="hasNextImageLink(subLink.links, nestedSubLinkIndex)"
                                >
                                  <a
                                    :href="nestedSubLink.url"
                                    class="subnavlink"
                                    @mouseover="subnavlinkHover"
                                    v-html="nestedSubLink.title"
                                  />
                                  <a :href="nestedSubLink.url" class="subnavlink subnavlink-img">
                                    <img
                                      v-lazy="subLink.links[nestedSubLinkIndex + 1].url"
                                      alt="Product category image"
                                      loading="lazy"
                                      width="130"
                                      height="130"
                                      decoding="async"
                                    />
                                  </a>
                                </template>
                                <template v-else-if="nestedSubLink.url === '#'">
                                  <span
                                    class="subnavlink subnavlink-heading"
                                    v-html="nestedSubLink.title"
                                  />
                                </template>
                                <template v-else>
                                  <a
                                    :href="nestedSubLink.url"
                                    class="subnavlink"
                                    v-html="nestedSubLink.title"
                                  />
                                </template>
                              </li>
                            </template>
                          </template>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <!--  Takat & WALLETS End -->
                </template>
              </template>
            </li>

            <template v-if="logoImageIndex === 3">
              <li v-if="HeaderNavData[2]" class="navitem">
                <a
                  :href="HeaderNavData[2].url"
                  class="navlink navlink_drpdown"
                  v-html="HeaderNavData[2].title"
                />
              </li>
            </template>
          </ul>

          <!-- Header logo -->
          <div class="logo_wrap line-h-0">
            <template v-if="HeaderNavData[logoImageIndex]">
              <a
                class="logo d-inline-block"
                :href="HeaderNavData[logoImageIndex].url"
                aria-label="Go to homepage"
                v-html="HeaderNavData[logoImageIndex].title"
              />
            </template>
          </div>

          <!-- Rigth Navlist -->
          <ul class="navlist navlist-right">
            <li class="navitem">
              <template v-if="HeaderNavData[logoImageIndex + 1]">
                <a :href="HeaderNavData[logoImageIndex + 1].url" class="navlink navlink_drpdown">
                  {{ HeaderNavData[logoImageIndex + 1].title }}
                </a>
                <template v-if="hasSubLinksAt(logoImageIndex + 1)">
                  <!-- CLIENT SERVICES Start -->
                  <div
                    class="navlink__hover"
                    role="menu"
                    @mouseenter="stopScroll"
                    @mouseleave="workScroll"
                  >
                    <ul class="navink__hover_list">
                      <li
                        v-for="subLink in HeaderNavData[logoImageIndex + 1].links"
                        :key="subLink.title"
                        class="navlink__hover_item"
                        role="menuitem"
                      >
                        <ul class="subnavlink__list">
                          <li
                            v-for="nestedSubLink in subLink.links"
                            :key="nestedSubLink.title"
                            class="subnavlink__item"
                          >
                            <template v-if="nestedSubLink.url === '#'">
                              <span class="subnavlink" v-html="nestedSubLink.title" />
                            </template>
                            <template v-else>
                              <a
                                :href="nestedSubLink.url"
                                class="subnavlink"
                                v-html="nestedSubLink.title"
                              />
                            </template>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <!-- CLIENT SERVICES End -->
                </template>
              </template>
            </li>
            <li class="navitem">
              <template v-if="HeaderNavData[logoImageIndex + 2]">
                <a
                  :href="HeaderNavData[logoImageIndex + 2].url"
                  class="navlink navlink_drpdown"
                  v-html="HeaderNavData[logoImageIndex + 2].title"
                />
                <template v-if="hasSubLinksAt(logoImageIndex + 2)">
                  <!-- THE SENSE OF BEHNO Start -->
                  <div
                    class="navlink__hover"
                    role="menu"
                    @mouseenter="stopScroll"
                    @mouseleave="workScroll"
                  >
                    <ul class="navink__hover_list">
                      <!-- ===   ON hover Class Show First row ===  -->
                      <li
                        v-for="subLink in HeaderNavData[logoImageIndex + 2].links"
                        :key="subLink.title"
                        class="navlink__hover_item"
                        role="menuitem"
                      >
                        <ul class="subnavlink__list">
                          <li
                            v-for="nestedSubLink in subLink.links"
                            :key="nestedSubLink.title"
                            class="subnavlink__item"
                          >
                            <template v-if="nestedSubLink.url === '#'">
                              <span class="subnavlink" v-html="nestedSubLink.title" />
                            </template>
                            <template v-if="isImageUrl(nestedSubLink.title)">
                              <a :href="nestedSubLink.url" class="nav_sensebehno__img subnavlink">
                                <img
                                  v-lazy="nestedSubLink.title"
                                  alt="The Sense of Behno collection"
                                  loading="lazy"
                                  decoding="async"
                                />
                              </a>
                            </template>
                            <template v-else>
                              <a
                                :href="nestedSubLink.url"
                                class="subnavlink"
                                v-html="nestedSubLink.title"
                              />
                            </template>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <!-- THE SENSE OF BEHNO End -->
                </template>
              </template>
            </li>
            <!-- Header Button Group -->
            <li class="desktop_btn_grp">
              <div class="nav_btns">
                <button
                  id="searcBtn"
                  ref="searchBtn"
                  class="search_btn"
                  type="button"
                  aria-label="Open search"
                  aria-expanded="false"
                  aria-controls="mainSearchBar"
                  @click="toggleSearchBar"
                >
                  <img
                    src="https://cdn.shopify.com/s/files/1/1000/3130/files/search.svg?v=1676479559"
                    alt="search icon"
                    loading="lazy"
                    width="15"
                    height="16"
                    decoding="async"
                    aria-hidden="true"
                  />
                </button>
                <button
                  ref="cartBtn"
                  class="shopping_btn"
                  type="button"
                  aria-label="Open shopping bag"
                  @click="toggleCart"
                >
                  <img
                    v-lazy="shopifyData.bag"
                    alt=""
                    loading="lazy"
                    width="26"
                    height="29"
                    decoding="async"
                    aria-hidden="true"
                  />
                  <span class="shopping_btn_count" aria-live="polite">{{
                    shopifyData.cartCount
                  }}</span>
                </button>
              </div>
            </li>
          </ul>
          <!-- Responsive Mobile Btn Grp -->
          <div class="mobile_btn_grp">
            <div class="nav_btns">
              <button
                class="search_btn"
                type="button"
                aria-label="Open search"
                @click="toggleSearchBar"
              >
                <img
                  src="https://cdn.shopify.com/s/files/1/1000/3130/files/search.svg?v=1676479559"
                  alt=""
                  loading="lazy"
                  width="15"
                  height="16"
                  decoding="async"
                  aria-hidden="true"
                />
              </button>
              <button
                class="shopping_btn"
                type="button"
                aria-label="Open shopping bag"
                @click="toggleCart"
              >
                <img
                  v-lazy="shopifyData.bag"
                  alt=""
                  loading="lazy"
                  width="26"
                  height="29"
                  decoding="async"
                  aria-hidden="true"
                />
                <span class="shopping_btn_count" aria-live="polite">{{
                  shopifyData.cartCount
                }}</span>
              </button>
            </div>
          </div>
        </nav>
      </div>
      <!-- ======= Desktop Navigation End ======= -->

      <!-- ======= Mobile Navigation Start ======= -->
      <nav
        id="mobile-navigation"
        class="m_navbar_list navbar-Mobile"
        role="navigation"
        aria-label="Mobile navigation"
      >
        <ul class="m_navlist d-block w-100">
          <li v-for="link in MobileNavData" :key="link.title" class="m_navitem">
            <template v-if="link.url === '#'">
              <span class="navlink w-100 t-left" />
            </template>
            <template v-else-if="link.links.length > 0">
              <button
                class="navlink nav_drpbtn w-100 t-left"
                type="button"
                aria-expanded="false"
                @click="toggleDropDown"
                v-html="link.title"
              />
              <div class="nav_drpbtn_content">
                <ul class="m_drpdown_list">
                  <!--  sub nav link  -->
                  <li v-for="subLink in link.links" :key="subLink.title" class="m_drpdown_item">
                    <template v-if="subLink.links.length > 0">
                      <button
                        class="subnavlink btn-best w-100 t-left"
                        type="button"
                        aria-expanded="false"
                        @click="toggleSubDropDown"
                        v-html="subLink.title"
                      />
                      <div class="nav_drpbtn_content qwe">
                        <ul class="m_subnavlink_list for-bestseller">
                          <li class="m_subnavlink_bestSell">
                            <button
                              class="m_subnavlink_bestSell_btn"
                              type="button"
                              aria-label="Go back"
                              @click="toggleSubDropDown"
                            />
                          </li>
                          <template
                            v-for="(nestedSubLink, nestedSubLinkIndex) in subLink.links"
                            :key="nestedSubLink.title"
                          >
                            <template v-if="!isImageUrl(nestedSubLink.url)">
                              <li class="m_subnavlink_item">
                                <template
                                  v-if="hasNextImageLink(subLink.links, nestedSubLinkIndex)"
                                >
                                  <a :href="nestedSubLink.url" class="navlink navlink-img">
                                    <img
                                      v-lazy="subLink.links[nestedSubLinkIndex + 1].url"
                                      alt="Product category"
                                      loading="lazy"
                                      decoding="async"
                                    />
                                  </a>
                                  <a
                                    :href="nestedSubLink.url"
                                    class="navlink"
                                    v-html="nestedSubLink.title"
                                  />
                                </template>
                                <template v-else-if="nestedSubLink.url === '#'">
                                  <span class="navlink" v-html="nestedSubLink.title" />
                                </template>
                                <template v-else>
                                  <a
                                    :href="nestedSubLink.url"
                                    class="navlink"
                                    v-html="nestedSubLink.title"
                                  />
                                </template>
                              </li>
                            </template>
                          </template>
                        </ul>
                      </div>
                    </template>
                    <template v-else>
                      <a :href="subLink.url" class="subnavlink" v-html="subLink.title" />
                    </template>
                  </li>
                </ul>
              </div>
            </template>
            <template v-else>
              <a :href="link.url" class="navlink w-100 t-left" v-html="link.title" />
            </template>
          </li>
        </ul>
      </nav>
      <!-- ======= Mobile Navigation End ======= -->
      <!-- ======= Search Bar Start ======= -->
      <div id="mainSearchBar" ref="mainSearchBar" class="main_search_bar" role="search">
        <form
          id="searchBar"
          action="/search"
          method="get"
          class="search_bar_items"
          @submit="handleSearchSubmit"
        >
          <button type="submit" class="search_icon" aria-label="Submit search">
            <img
              v-lazy="shopifyData.search"
              alt=""
              loading="lazy"
              width="20"
              height="20"
              decoding="async"
              aria-hidden="true"
            />
          </button>
          <input type="hidden" name="type" value="product" />
          <input
            id="serchInput"
            ref="searchInput"
            type="search"
            name="q"
            class="search_item"
            placeholder="Search products..."
            autocomplete="off"
            aria-label="Search products"
          />
          <button type="button" aria-label="Close search" @click="toggleSearchBar()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-x"
              aria-hidden="true"
              focusable="false"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </form>
        <div id="pageheader">
          <div class="result_wrapper">
            <div id="loader2" ref="searchLoader" aria-hidden="true" />
            <div
              ref="resultsBox"
              class="results-box"
              style="display: flex"
              role="listbox"
              aria-label="Search results"
            />
            <span ref="infoText" class="info_text">We're sorry, no matches were found.</span>
            <a ref="viewAllResults" href="#" class="view_all_results">View all</a>
          </div>
        </div>
      </div>
      <!-- ======= Search Bar End ======= -->
    </div>
  </header>
  <!-- ====== Shoping Mini Cart ====== -->
  <section class="mini_cart" data-lenis-prevent aria-label="Shopping cart">
    <div
      ref="miniCartContainer"
      :class="['mini_cart_container']"
      data-lenis-prevent
      data-lenis-prevent-wheel
      role="dialog"
      aria-modal="true"
      aria-labelledby="cart-title"
    >
      <div class="mini_cart-header">
        <h3 id="cart-title" aria-label="Shopping cart title">YOUR BAG</h3>
        <button id="remove-btn" type="button" aria-label="Close shopping bag" @click="toggleCart">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="33"
            viewBox="0 0 48 48"
            fill="none"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M11.8861 11.8865L35.6587 35.6591" stroke="#656565" stroke-width="1.5" />
            <path d="M11.8861 35.6587L35.6587 11.8861" stroke="#656565" stroke-width="1.5" />
          </svg>
        </button>
      </div>
      <div>
        <span class="brk_line" aria-hidden="true" />

        <!-- if card is not empty  -->
        <div id="mini_cart_content" aria-live="polite" />

        <!-- if cart is empty  -->
        <div class="if_cart_is_empty">
          <p>Your bag is empty.</p>
        </div>
      </div>

      <div class="mini_cart-payment">
        <span class="brk_line" aria-hidden="true" />
        <div class="sec_right">
          <form>
            <div class="sec_right_inner cart__footer">
              <h4 class="subtotal_heading">SUBTOTAL</h4>
              <p class="subtotal_price body_text">$1,080</p>
              <p class="body_text cart__subtotal">Including tax & shipping</p>
              <p class="body_text text-mdifier">
                or 4 interest payments of {{ currencySymbol }}
                <span id="afterpay_insert_data" /> with
              </p>
              <div class="logo_wrapper">
                <img
                  src="https://cdn.shopify.com/s/files/1/1000/3130/files/afterpay-logo.png?v=1625324776"
                  alt="Afterpay - Buy now, pay later"
                  loading="lazy"
                  width="75"
                  height="14"
                  decoding="async"
                />
                <button
                  type="button"
                  class="body_text"
                  style="cursor: pointer"
                  aria-label="Learn more about Afterpay"
                  @click="showAfterPayModel"
                >
                  ⓘ
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="mini_shopping_cart">
          <a href="/cart" class="shp_cart">View shopping cart</a>
        </div>
      </div>
    </div>
    <span
      ref="bgLayerRemovecart"
      class="bg_layer_removecart"
      data-lenis-prevent
      aria-hidden="true"
      @click="handleCartOverlayClick"
    />
    <div ref="miniAddCard" class="mini-add-card">
      <a href="/checkout" class="add-card-chk">CHECKOUT</a>
    </div>
    <div id="overlay" ref="overlay" @click="togleHeader" />
  </section>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';

import { currencyJson } from '@/currency';
import { ShopifyAPI } from '../../Shopify/Shopify';

// Utility functions
const IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.svg', '.webp', '.gif'];

const isImageUrl = (url) => {
  if (!url) return false;
  const lowerUrl = url.toLowerCase();
  return IMAGE_EXTENSIONS.some((ext) => lowerUrl.includes(ext));
};

const debounce = (fn, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn(...args), delay);
  };
};

const parseInventoryData = (encodedData) => {
  try {
    if (!encodedData) return [];
    const decoded = atob(encodedData);
    const cleanJson = decoded.replace(/&quot;/g, '"');
    let parsed = JSON.parse(cleanJson);

    if (typeof parsed === 'string') {
      parsed = JSON.parse(parsed);
    }

    if (!Array.isArray(parsed)) return [];

    return parsed.map((item) => ({
      ...item,
      product: {
        ...item.product,
        availableInventory: item.product?.availableInventory ?? 0,
      },
    }));
  } catch {
    return [];
  }
};

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      logoImageIndex: 0,
      lastScrollY: 100,
      show: true,
      HeaderNavData: this.shopifyData.HeaderNavData || [],
      MobileNavData: this.shopifyData.MobileNavData || [],
      ProductInventoryData: parseInventoryData(this.shopifyData.ProductInventoryData),
      slider: [],
      swiperModules: [Autoplay, EffectFade],
      currencySymbol: '',
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      isCountdownFinished: false,
      countdownInterval: null,
      headerElement: null,
      searchDebounceTimeout: null,
    };
  },
  computed: {
    color() {
      return { color: this.shopifyData.textColor };
    },
    countTextColor() {
      return { color: this.shopifyData.countTextColor };
    },
    countBarBgColor() {
      return { backgroundColor: this.shopifyData.countBarBgColor };
    },
    hasMultipleSlides() {
      return this.slider.length > 1;
    },
    hasBarLink() {
      return this.shopifyData.barLink !== 'blank';
    },
    announcementBarStyle() {
      return {
        display: this.shopifyData.showAnnouncement === 'true' ? 'block' : 'none',
        backgroundColor: this.shopifyData.barBgColor,
      };
    },
    countdownBarStyle() {
      return {
        display: this.shopifyData.showCountDownBar === 'true' ? 'block' : 'none',
      };
    },
  },
  mounted() {
    // Cache header element
    this.headerElement = document.querySelector('.tmbHeader');

    // Initialize currency symbol
    this.currencySymbol = currencyJson[window?.Shopify?.currency?.active]?.symbol_native || '$';

    // ================= header skelton remove ===========//
    document.getElementById('header-skeleton')?.remove();
    document.getElementById('vue-header').style.display = 'block';

    // Set logo image index
    this.initializeLogoIndex();

    // Add event listeners with proper binding
    this.boundScrollHandler = debounce(this.scollHeader.bind(this), 10);
    this.boundResizeHandler = debounce(this.setDynamicTop.bind(this), 100);

    window.addEventListener('scroll', this.boundScrollHandler, { passive: true });
    window.addEventListener('resize', this.boundResizeHandler, { passive: true });
    window.addEventListener('load', this.setDynamicTop);

    // Initialize features
    this.initializeLiveSearch();
    this.initializeCountdown();
    this.refreshMiniCart();
    this.setDynamicTop();

    // Setup cart overlay click handler
    this.$nextTick(() => {
      const bgLayer = this.$refs.bgLayerRemovecart;
      if (bgLayer) {
        bgLayer.addEventListener('click', this.handleCartOverlayClick);
      }
    });
  },
  beforeUnmount() {
    // Clean up all event listeners
    window.removeEventListener('scroll', this.boundScrollHandler);
    window.removeEventListener('resize', this.boundResizeHandler);
    window.removeEventListener('load', this.setDynamicTop);

    // Clear intervals
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }

    // Clear search debounce
    if (this.searchDebounceTimeout) {
      clearTimeout(this.searchDebounceTimeout);
    }

    // Remove cart overlay listener
    const bgLayer = this.$refs.bgLayerRemovecart;
    if (bgLayer) {
      bgLayer.removeEventListener('click', this.handleCartOverlayClick);
    }
  },
  methods: {
    // Helper methods
    isImageUrl,

    hasSubLinks(index) {
      return this.HeaderNavData[index]?.links?.length > 0;
    },

    hasSubLinksAt(index) {
      return this.HeaderNavData[index]?.links?.length > 0;
    },

    hasNextImageLink(links, currentIndex) {
      const nextLink = links[currentIndex + 1];
      return nextLink && isImageUrl(nextLink.url);
    },

    initializeLogoIndex() {
      this.HeaderNavData.forEach((element, index) => {
        if (isImageUrl(element.title)) {
          this.logoImageIndex = index;
        }
      });
    },

    showAnnouncement() {
      return this.announcementBarStyle;
    },

    showCountDown() {
      return this.countdownBarStyle;
    },

    // Countdown Timer
    initializeCountdown() {
      const { startYear, startMonth, startDay, endYear, endMonth, endDay } = this.shopifyData;

      if (!startYear || !startMonth || !startDay || !endYear || !endMonth || !endDay) {
        return;
      }

      const second = 1000;
      const minute = second * 60;
      const hour = minute * 60;
      const day = hour * 24;

      // console.log('Countdown Dates:', {
      //   startDate: `${startYear}-${startMonth}-${startDay}`,
      //   endDate: `${endYear}-${endMonth}-${endDay}`,
      // });

      const startDate = new Date(
        Number(startYear),
        Number(startMonth) - 1,
        Number(startDay),
        0,
        0,
        0
      );

      const endDate = new Date(Number(endYear), Number(endMonth) - 1, Number(endDay), 23, 59, 59);

      this.countdownInterval = setInterval(() => {
        const now = new Date();

        // Before sale starts
        if (now < startDate) {
          // console.log('Countdown not started yet. Current time:', now, 'Start date:', startDate);
          this.isCountdownFinished = true; // Hide countdown
          this.days = this.hours = this.minutes = this.seconds = 0;
          return;
        }

        // After sale ends
        if (now > endDate) {
          // console.log('Countdown finished. Current time:', now, 'End date:', endDate);
          clearInterval(this.countdownInterval);
          this.isCountdownFinished = true; // Hide countdown
          this.days = this.hours = this.minutes = this.seconds = 0;
          return;
        }

        // Sale is active -> countdown to END date
        this.isCountdownFinished = false;

        const distance = endDate.getTime() - now.getTime();

        this.days = Math.floor(distance / day);
        this.hours = Math.floor((distance % day) / hour);
        this.minutes = Math.floor((distance % hour) / minute);
        this.seconds = Math.floor((distance % minute) / second);
      }, 1000);
    },
    // Live Search
    initializeLiveSearch() {
      const searchInput = this.$refs.searchInput;
      if (!searchInput) return;

      searchInput.addEventListener('keyup', this.handleSearchInput);
    },

    handleSearchInput(e) {
      clearTimeout(this.searchDebounceTimeout);

      this.searchDebounceTimeout = setTimeout(() => {
        const loader = this.$refs.searchLoader;
        const resultsBox = this.$refs.resultsBox;
        const infoText = this.$refs.infoText;
        const term = e.target.value.trim();

        if (!term) {
          // Clear everything when input is empty
          if (resultsBox) {
            resultsBox.innerHTML = '';
            resultsBox.style.height = '0';
            resultsBox.style.display = 'none';
            resultsBox.style.overflow = 'hidden';
          }
          if (infoText) {
            infoText.style.display = 'none';
          }
          this.hideViewAllResults();
          return;
        }

        if (loader) loader.style.display = 'block';

        const formAction = e.target.closest('form')?.getAttribute('action') || '/search';

        fetch(`${formAction}?type=product&view=json&q=${encodeURIComponent(term)}`, {
          headers: { 'Content-Type': 'application/json' },
        })
          .then((response) => response.text())
          .then((responseText) => {
            if (loader) loader.style.display = 'none';

            const parser = new DOMParser();
            const doc = parser.parseFromString(responseText, 'text/html');
            const searchDataEl = doc.querySelector('#search_data');

            if (!searchDataEl) return;

            const allItems = JSON.parse(searchDataEl.innerHTML);
            const searchTerm = term.toLowerCase();
            // Split search term into words, filter out "OR" operator (e.g., "navy OR blue" -> ["navy", "blue"])
            const searchWords = searchTerm
              .split(/\s+/)
              .filter((word) => word.length > 0 && word.toLowerCase() !== 'or');

            // Filter and sort results
            const filteredResults = allItems.results
              .filter((item) => {
                const title = item.title.toLowerCase();
                const tags = item.tags ? item.tags.toLowerCase().split(',') : [];
                // Check if ANY search word matches title or tags
                return searchWords.some(
                  (word) => title.includes(word) || tags.some((tag) => tag.trim().includes(word))
                );
              })
              .sort((a, b) => {
                const scoreA = this.getMatchScore(a.title.toLowerCase(), searchTerm);
                const scoreB = this.getMatchScore(b.title.toLowerCase(), searchTerm);
                return scoreB - scoreA;
              });

            this.renderSearchResults(filteredResults, formAction, term);
          })
          .catch(() => {
            if (loader) loader.style.display = 'none';
          });
      }, 300);
    },

    getMatchScore(title, searchTerm) {
      let score = 0;
      let titleIndex = 0;
      for (const char of searchTerm) {
        if (title[titleIndex] === char) {
          score++;
          titleIndex++;
        }
      }
      return score;
    },

    renderSearchResults(results, formAction, term) {
      const resultsBox = this.$refs.resultsBox;
      const infoText = this.$refs.infoText;
      const viewAllResults = this.$refs.viewAllResults;

      if (!resultsBox) return;

      const html = results
        .map(
          (item) => `
          <div class="search_items_wrapper">
            <a href="${item.url}">
              <img src="${item.thumb}" alt="${item.title}" loading="lazy" decoding="async">
              <h2>${item.title}</h2>
            </a>
          </div>
        `
        )
        .join('');

      resultsBox.innerHTML = html;
      this.adjustResultsBoxHeight(resultsBox);

      if (results.length === 0) {
        // No results found - show info text, hide view all
        if (infoText) {
          infoText.classList.remove('hide');
          infoText.style.display = 'block';
        }
        this.hideViewAllResults();
      } else {
        // Results found - hide info text, show view all
        if (infoText) {
          infoText.classList.add('hide');
          infoText.style.display = 'none';
        }
        if (viewAllResults) {
          viewAllResults.classList.add('show');
          viewAllResults.href = `${formAction}?type=product&q=${encodeURIComponent(term)}`;
        }
      }
    },

    adjustResultsBoxHeight(resultsBox) {
      if (!resultsBox) return;
      const windowHeight = window.innerHeight;
      const offset = resultsBox.getBoundingClientRect().top;
      resultsBox.style.display = 'flex'; // Restore display when showing results
      resultsBox.style.height = `${windowHeight - offset - 20}px`;
      resultsBox.style.overflowY = 'auto';
      resultsBox.style.overflow = 'auto';
    },

    hideViewAllResults() {
      const viewAllResults = this.$refs.viewAllResults;
      if (viewAllResults) viewAllResults.classList.remove('show');
    },

    handleSearchSubmit(e) {
      const searchInput = this.$refs.searchInput;
      const searchValue = searchInput?.value.trim();

      if (!searchValue) {
        e.preventDefault();
      }
      // Multi-word search handling is done in liquid template
      // It loads all products when search.results is empty for multi-word queries
      // Then Vue component filters client-side to show products matching ANY word
    },

    // Dynamic Top Calculation
    setDynamicTop() {
      if (!this.headerElement) return;

      const headerHeight = this.headerElement.offsetHeight;
      const mainSearchBar = this.$refs.mainSearchBar;
      const tmbMain = document.querySelector('.tmbMain');
      const navDropDowns = document.querySelectorAll('.navlink__hover');
      const navDropDownMob = document.querySelectorAll('.navbar-Mobile');

      if (mainSearchBar?.classList.contains('show')) {
        mainSearchBar.style.transform = `translateY(${headerHeight}px)`;
      } else if (mainSearchBar) {
        mainSearchBar.removeAttribute('style');
      }

      if (tmbMain) {
        tmbMain.style.marginTop = `${headerHeight}px`;
      }

      navDropDowns.forEach((el) => {
        el.style.top = `${headerHeight}px`;
      });

      navDropDownMob.forEach((el) => {
        el.style.top = `${headerHeight}px`;
      });
    },

    closeAnnouncementBar() {
      const announcementBar = this.$refs.announcementBar;
      if (announcementBar) {
        announcementBar.classList.add('barClose');
        this.setDynamicTop();
      }
    },

    showAfterPayModel() {
      const modal = document.querySelector('afterpay-modal');
      if (modal) {
        modal.setAttribute('data-modal-id', '');
        modal.setAttribute('data-locale', 'en_US');
        modal.setAttribute('data-modal-theme', 'null');
        modal.setAttribute('data-cbt-enabled', 'false');
        modal.setAttribute('data-apr-loans-available', 'false');
        modal.setAttribute('visible', 'visible');
      }
    },

    toggleSubDropDown(e) {
      const currentElement = e.currentTarget;
      const mobileNav = document.querySelector('.navbar-Mobile');

      if (mobileNav) mobileNav.scrollTop = 0;

      const activeSubnavlink = document.querySelector('.subnavlink.active');
      if (activeSubnavlink && activeSubnavlink !== currentElement) {
        activeSubnavlink.classList.remove('active');
      } else {
        currentElement.classList.toggle('active');
      }
    },

    toggleSearchBar() {
      const tmbHeader = this.headerElement;
      if (tmbHeader?.classList.contains('active')) {
        tmbHeader.classList.remove('active');
      }

      const searchInput = this.$refs.searchInput;
      const resultsBox = this.$refs.resultsBox;
      const mainSearchBar = this.$refs.mainSearchBar;
      const infoText = this.$refs.infoText;

      // Clear search input
      if (searchInput) searchInput.value = '';

      // Clear results completely - reset to fresh state
      if (resultsBox) {
        resultsBox.innerHTML = '';
        resultsBox.style.height = '0';
        resultsBox.style.overflowY = '';
      }

      // Hide view all results link
      this.hideViewAllResults();

      // Reset info text to hidden state
      if (infoText) {
        infoText.classList.remove('hide');
        infoText.style.display = 'none';
      }

      // Clear any pending search debounce
      if (this.searchDebounceTimeout) {
        clearTimeout(this.searchDebounceTimeout);
        this.searchDebounceTimeout = null;
      }

      if (mainSearchBar) {
        mainSearchBar.classList.toggle('show');
        if (mainSearchBar.classList.contains('show')) {
          // Reset info text when opening fresh
          if (infoText) infoText.style.display = '';
          this.$nextTick(() => searchInput?.focus());
        }
      }

      this.setDynamicTop();
    },

    toggleCart() {
      const miniCartContainer = this.$refs.miniCartContainer;
      const miniAddCard = this.$refs.miniAddCard;

      if (miniCartContainer) miniCartContainer.classList.toggle('active');
      if (miniAddCard) miniAddCard.classList.toggle('active');

      // Lock/unlock body scroll when cart is toggled
      const isActive = miniCartContainer?.classList.contains('active');
      if (isActive) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },

    handleCartOverlayClick() {
      const miniCartContainer = this.$refs.miniCartContainer;
      const miniAddCard = this.$refs.miniAddCard;

      if (miniCartContainer) miniCartContainer.classList.remove('active');
      if (miniAddCard) miniAddCard.classList.remove('active');

      // Unlock body scroll when cart overlay is clicked
      document.body.style.overflow = '';
    },

    refreshMiniCart() {
      try {
        const refreshCart = new ShopifyAPI();
        refreshCart.refreshMiniCart();
      } catch {
        // Silently handle error
      }
    },

    togleHeader() {
      const mainSearchBar = this.$refs.mainSearchBar;
      if (mainSearchBar?.classList.contains('show')) {
        mainSearchBar.classList.remove('show');
        mainSearchBar.removeAttribute('style');
      }

      if (this.headerElement?.classList.contains('active')) {
        document.querySelectorAll('.nav_drpbtn.active').forEach((el) => el.click());
      }

      this.headerElement?.classList.toggle('active');
      const isActive = this.headerElement?.classList.contains('active');
      const overlay = this.$refs.overlay;

      if (isActive) {
        document.body.style.overflow = 'hidden';
        overlay?.classList.add('show');
      } else {
        document.body.removeAttribute('style');
        overlay?.classList.remove('show');
      }
    },

    toggleDropDown(e) {
      const target = e.currentTarget;
      const nextSibling = target.nextElementSibling;

      if (target.matches('.subnavlink')) {
        const parentElement = target.closest('.nav_drpbtn_content');
        if (parentElement && nextSibling) {
          const heightAdjust = target.matches('.active')
            ? -nextSibling.scrollHeight
            : nextSibling.scrollHeight;
          parentElement.style.height = `${parentElement.offsetHeight + heightAdjust}px`;
        }
      }

      if (target.matches('.active')) {
        nextSibling?.removeAttribute('style');
      } else if (nextSibling) {
        nextSibling.style.height = `${nextSibling.scrollHeight}px`;
      }

      target.classList.toggle('active');
    },

    scollHeader() {
      if (!this.headerElement) return;

      if (window.scrollY >= this.lastScrollY) {
        this.headerElement.classList.add('stickyup');
      } else {
        this.headerElement.classList.remove('stickyup');
      }

      if (window.scrollY >= 100) {
        this.lastScrollY = window.scrollY;
      }
    },

    subnavlinkHover(e) {
      const list = e.currentTarget.closest('.subnavlink__list');
      const alreadyActive = list?.querySelector('.hover_active');

      if (alreadyActive) {
        alreadyActive.classList.remove('hover_active');
      }
      e.currentTarget.classList.add('hover_active');
    },

    stopScroll() {
      // Intentionally empty - preserved for hover event compatibility
    },

    workScroll() {
      // Intentionally empty - preserved for hover event compatibility
    },
  },
};
</script>

<style>
.tmbHeader .navlist a,
.tmbHeader button {
  transition: 0.2s;
}

.breadcrumb {
  display: block !important;
}

.tmbHeader .navlist a {
  font-family: 'Arial', 'Noto Sans', sans-serif;
}

.miniCart_incre_btn.disabled {
  position: relative;
  pointer-events: none;
  opacity: 0.3 !important;
  cursor: not-allowed !important;
}

.miniCart_incre_btn.disabled:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  transform: translate(-50%, -50%);
  cursor: not-allowed !important;
  z-index: 2;
  pointer-events: none;
}

.tmbHeader .navlist.subnavlink:hover,
.tmbHeader button:hover {
  opacity: 0.5;
}

button.behno_increment_dec {
  position: relative;
  display: flex;
}

button.behno_increment_dec:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* .tmbMain {
  margin-top: 100px;
} */
.behno_increment_dec.miniCart_incre_btn.loading {
  height: 21px !important;
  width: 21px !important;
}
.behno_increment_dec.miniCart_decre_btn.loading {
  height: 21px !important;
  width: 21px !important;
}

@media only screen and (max-width: 991px) {
  /* .tmbMain {
    margin-top: 60px;
  } */

  #overlay {
    position: fixed;
    opacity: 0;
    visibility: hidden;
    transition: 0.3s;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 4;
    cursor: pointer;
  }

  #overlay.show {
    opacity: 1;
    visibility: visible;
  }
}

.mini_cart_container .card {
  padding-bottom: 30px;
  position: relative;
}

.mini_cart_container .card .subtitle_b {
  margin-top: 5px;
}

.mini_cart_container .card:not(:last-child):after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: calc(100% + 36px);
  background: #000;
  height: 1px;
  margin-left: -18px;
}

.mini_cart_container .card:not(:first-child) {
  margin-top: 23px;
}

/*------- Mini Cart Css -------*/

.product_img_wrapper {
  position: relative;
  margin-bottom: 11px;
  line-height: 1;
}

.mini_cart {
  position: relative;
  overflow: hidden;
}

.mini_cart_container {
  max-width: 377px;
  background-color: white;
  width: 100%;
  min-height: 100vh;
  height: 100%;
  overflow-y: scroll;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 6;
  border: 1px solid black;
  transition: 0.3s;
  transform: translateX(110%);
  padding: 30px 42px 100px;
  overscroll-behavior: none;
}

.mini-add-card {
  max-width: 377px;
  width: 100%;
  position: fixed;
  right: 0;
  top: auto;
  bottom: 0;
  z-index: 6;
  transition: 0.3s;
  transform: translateX(110%);
  text-align: center;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
}

.mini_cart_container::-webkit-scrollbar {
  display: none;
}

.mini_cart .remove {
  position: absolute;
  text-decoration: underline;
  top: 13px;
  right: 11px;
  z-index: 1;
}

.mini_cart .body_text {
  font-family: inherit;
}

.mini_cart-header {
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  margin-bottom: 26px;
}

.mini_cart-header #remove-btn svg {
  display: block;
}

.mini_cart-header h3 {
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.02em;
}

.mini_cart-products {
  display: flex;
  align-items: center;
  margin: 26px 0 0;
}

.mini_cart-products.third-party-free-gift {
  display: none;
}
.mini_cart-products span {
  margin: 0 36px;
}

.mini_cart-products span input {
  border: none;
  width: 25px;
  text-align: center;
}

.mini_cart-products span input:focus {
  outline: none;
}

.mini_cart .subtotal_price.body_text {
  font-weight: 700;
  font-size: 15px;
  line-height: 18.31px;
}

.mini_cart-payment {
  display: flex;
  gap: 50px;
  flex-direction: column;
  justify-content: space-between;
}

.add-card-chk {
  color: white;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  padding: 21px;
  background: #000;
  width: 100%;
  display: block;
  transition: 0.3s;
  border: 1px solid transparent;
}

@media (min-width: 991px) {
  .add-card-chk:hover {
    border: 1px solid #000;
    color: #000;
    background: #fff;
  }
}

.mini_shopping_cart {
  margin: 40px 0 80px;
}

.shp_cart {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.02em;
  text-decoration-line: underline;
}

.brk_line {
  min-width: 328px;
  height: 1px;
  background-color: black;
  display: block;
  margin: 0 -22px 89px;
}

.if_cart_is_empty {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  letter-spacing: 0.02em;
  color: #000000;
}

.mini_cart_container.active,
.mini-add-card.active {
  transform: translateX(0);
}

.logo_wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
}

.logo_wrapper > img {
  width: 75px;
  height: auto;
  aspect-ratio: 75 / 14;
}

.subtotal_heading {
  margin-bottom: 30px;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.02em;
  color: #000000;
}

.mini_cart-payment .body_text.text-mdifier {
  margin-bottom: 20px;
}

.subtotal_price + .body_text {
  margin-bottom: 15px;
}

.body_text.remove {
  font-size: 12px;
  line-height: 14px;
}

.active.mini_cart_container + .bg_layer_removecart {
  visibility: visible;
  transition: 0.3s;
}

.bg_layer_removecart {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: #000;
  opacity: 0.3;
  z-index: 5;
  visibility: hidden;
}
</style>

<style scoped>
.productInventory {
  display: flex;
  opacity: 0;
  position: absolute;
}

.announcement_bar {
  background-color: #000;

  width: 100%;
  text-align: center;
}

.announcement_content {
  position: relative;
}

.announcement_bar_text {
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: #fff;
  padding: 8px 0;
  width: 88%;
  margin: 0 auto;
}

.closeIcon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  width: 14px;
  height: 14px;
  cursor: pointer;
  z-index: 9;
  display: none;
  background: none;
  border: none;
  padding: 0;
}

.closeSvg {
  fill: #fff;
}

.barClose {
  display: none;
}

@media screen and (max-width: 767px) {
  .announcement_bar_text {
    font-size: 14px;
    line-height: 20px;
    padding: 13px 0;
  }
}

.tmbHeader .main_search_bar {
  position: fixed;
  max-width: 480px;
  width: 100%;
  right: 0;
  top: 0;
  background: #fff;

  /* Start hidden */
  transform: translateY(-100%);
  opacity: 0;
  pointer-events: none;

  transition:
    transform 0.35s ease,
    opacity 0.35s ease,
    box-shadow 0.35s ease;
}

.tmbHeader .main_search_bar.show {
  transform: translateY(0);
  opacity: 1;
  pointer-events: auto;
  box-shadow: 0 0 20px #eee;
}

.search_bar_items {
  display: flex;
  align-items: center;
  padding: 10px;
}

.search_item {
  border: none;
  margin: 0 10px;
  width: 100%;
  outline: none;
}

.search_icon img {
  width: 20px;
}

.search_item + button svg {
  width: 20px;
  height: 20px;
}

@media only screen and (max-width: 575px) {
  .tmbHeader .main_search_bar {
    max-width: 320px;
  }
}

/*   search bar */

.header_toggle_wrap,
.mobile_btn_grp,
.navbar-Mobile {
  display: none;
}

.tmbHeader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 5;
  transition: transform 0.5s;
}

.tmbHeader_new {
  padding: 14px 50px 10px;
}

@media screen and (min-width: 1440px) {
  .tmbHeader_new {
    height: 60px;
  }
}

.tmbHeader.stickyup {
  transform: translateY(-100%);
}

.navbar {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
}

.navlist {
  display: grid;
  gap: 45px;
  grid-auto-flow: column;
  align-items: center;
  justify-content: flex-start;
}

.navlist-right {
  justify-content: flex-end;
}

.navitem {
  display: flex;
}

.navlink,
.subnavlink {
  font-size: 12px;
  letter-spacing: 0.05em;
  position: relative;
  font-weight: 400;
  display: inline-block;
  line-height: 100%;
}

.nav_btns {
  display: grid;
  gap: 25px;
  grid-auto-flow: column;
  align-items: center;
  width: fit-content;
}

.logo {
  line-height: 0;
}

.nav_btns > a,
.nav_btns > button {
  display: grid;
  place-items: center;
}

.shopping_btn {
  position: relative;
  cursor: pointer;
}

.desktop_btn_grp .shopping_btn {
  margin-top: -10px;
}

.shopping_btn_count {
  position: absolute;
  bottom: 1px;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  letter-spacing: 0.05em;
  color: #000000;
}

.header_toggle {
  position: relative;
  height: 10px;
  width: 15px;
}

.toggle_bar {
  height: 1px;
  width: 100%;
  background: #000000;
  display: block;

  position: absolute;
  left: 0;
  transform-origin: center;
}

.toggle_bar-center {
  top: 50%;
  transform: translateY(-50%);
}

.toggle_bar-top {
  top: 0;
  transition:
    transform 0.3s,
    top 0.3s 0.3s;
}

.toggle_bar-bottom {
  bottom: 0;
  transition:
    transform 0.3s,
    bottom 0.3s 0.3s;
}

.active .toggle_bar-top {
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
  transition:
    top 0.3s,
    transform 0.3s 0.3s;
}

.active .toggle_bar-bottom {
  bottom: 50%;
  transition:
    bottom 0.3s,
    transform 0.3s 0.3s;
  transform: translateY(50%) rotate(-45deg);
}

.active .toggle_bar-center {
  opacity: 0;
}

.subnavlink__item {
  margin-bottom: 10px;
  display: flex;
}

.nanamoto-basics-crd {
  margin-top: 15px;
  padding: 50px 30px;
  background: #758f8f;
  width: 100%;
}

.nanamoto-basics-crd img {
  display: block;
}

.nanamoto-basics-crd-txt {
  display: inline-block;
  margin-top: 25px;
}

.nanamoto-basics-crd-txt a:first-child {
  margin-bottom: 15px;
}

.nanamoto-basics-crd-txt a {
  font-size: 13px;
  color: #fff;
  font-weight: 400;
  display: block;
}

.navlink__hover {
  position: fixed;
  top: 100px;
  height: 100%;
  min-height: 100vh;
  background: #eae8e4;
  max-width: 515px;
  width: 100%;
  padding: 40px 50px;
  z-index: 5;
  overflow-y: scroll;
  opacity: 0;
  visibility: hidden;
  transition:
    all 0.3s linear,
    max-width 0s;
}

.navlink__hover::-webkit-scrollbar {
  width: 3px;
}

.navlink__hover::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.navlist-left .navlink__hover {
  left: 0;
}

.navlist-right .navlink__hover {
  right: 0;
}

.navlink__hover_item {
  position: relative;
  margin-bottom: 60px;
}

.subnavlink-heading {
  font-weight: 700;
}

.first-navitem .subnavlink__list {
  width: calc(100% - 170px);
}

.hover-img .subnavlink-img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  display: block;
}

.navlist-left .subnavlink-img {
  height: 130px;
  width: 130px;
  object-fit: cover;
}

.nav_sensebehno__img {
  transform: translateX(50px);
}

@media (hover: hover) {
  .navlink_drpdown:hover {
    padding-bottom: 50px;
    margin-bottom: -50px;
  }

  .subnavlink:hover {
    color: #767676;
  }

  .subnavlink-heading:hover {
    color: #000;
    cursor: default;
  }

  .navlink_drpdown:hover + .navlink__hover,
  .navlink__hover:hover {
    opacity: 1;
    visibility: visible;
  }

  .subnavlink:hover + .subnavlink-img,
  .subnavlink.hover_active + .subnavlink-img {
    z-index: 2;
  }
}

@media only screen and (max-width: 1440px) {
  .tmbHeader_new {
    padding: 14px 20px 10px;
  }

  .navlist {
    gap: 25px;
  }
}

@media only screen and (max-width: 1024px) {
  .logo img {
    max-width: 70px;
  }
}

@media only screen and (max-width: 991px) {
  .tmbHeader_new {
    padding: 14.5px 20px;
  }

  .search_btn {
    margin-top: 7px;
  }

  .header_toggle_wrap,
  .mobile_btn_grp {
    display: flex;
  }

  .desktop_btn_grp,
  .navlist-left,
  .navlist-right {
    display: none;
  }

  .navlink,
  .subnavlink {
    font-size: 18px;
  }

  .nav_btns {
    margin: 0 0 0 auto;
  }

  .m_navbar_list {
    position: fixed;
    top: 65px;
    left: -100%;
    height: 100%;
    min-height: 100vh;
    max-width: 425px;
    width: 100%;
    background: #e9e7e3;
    padding: 37px 15px 125px;
    z-index: 5;
    display: block;
    transition: 0.5s;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .active .m_navbar_list {
    left: 0;
  }

  .m_navitem {
    padding: 0 20px 23px;
    border-bottom: 1px solid #000;
    margin-inline: -12px;
  }

  li.m_navitem:not(:first-child) {
    margin-top: 23px;
  }

  .nav_drpbtn::before,
  .btn-best::before {
    content: '';
    position: absolute;
    top: 50%;
    right: 5px;
    height: 9px;
    transition: 0.2s;
    width: 9px;
    transform-origin: center;
    border: 1px solid black;
    border-top: none;
    border-left: none;
    transform: translateY(-50%) rotate(45deg);
  }

  .nav_drpbtn::before {
    margin-top: -3px;
  }

  .btn-best.active::before {
    transform: translateY(-50%) rotate(317deg);
  }

  .nav_drpbtn.active::before {
    transform: translateY(-50%) rotate(225deg);
    margin-top: 3px;
  }

  .m_drpdown_list {
    margin: 37px 0 7px 17px;
  }

  .m_drpdown_item:not(:last-child) {
    margin-bottom: 30px;
  }

  .m_drpdown_item:first-child,
  .m_subnavlink_item:first-child,
  .m_navitem:first-child {
    margin-top: 0;
  }

  .subnavlink {
    font-weight: 400;
  }

  .nav_drpbtn_content {
    height: 0;
    overflow: hidden;
    transition: 0.2s;
  }

  .m_subnavlink_list {
    padding: 37px 25px 250px;
    position: absolute;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    left: 100%;
    top: 0;
    z-index: 2;
    transition: 0.4s;
    background-color: #e9e7e3;
    overflow-y: scroll;
    overscroll-behavior: contain;
  }

  .tmbHeader .navlist.subnavlink:hover,
  .tmbHeader button:hover {
    opacity: 1;
  }

  button.subnavlink.btn-best.active + .nav_drpbtn_content.qwe {
    height: auto;
  }

  button.subnavlink.btn-best.active + .nav_drpbtn_content .m_subnavlink_list {
    left: 0;
  }

  .m_subnavlink_item {
    margin-top: 10px;
  }

  button.m_subnavlink_bestSell_btn {
    width: 10px;
    height: 10px;
    border: 1px solid;
    border-left: 0;
    border-top: 0;
    transform: rotate(135deg);
    line-height: 0;
    margin: 0 0 18px 3px;
    display: block;
  }

  .navlink-img {
    max-width: 243px;
    width: 100%;
    margin: 25px 0 7px;
    display: block;
  }

  .btn-best {
    width: fit-content;
  }

  .btn-best::before {
    left: 100%;
    transform: translateY(-50%) rotate(315deg);
    margin-left: 10px;
  }

  .tmbHeader_new .main_search_bar {
    right: 0;
  }

  .tmbHeader_new .main_search_bar.show {
    transform: translate(-50%, 55px);
  }
}

@media only screen and (max-width: 767px) {
  .subtitle_b {
    margin-bottom: 0 !important;
  }
}

@media only screen and (max-width: 480px) {
  .navlink-img {
    width: 243px;
    max-width: 100%;

    margin: 25px 0 7px;
    display: block;
  }
}

/* ====== countdown css ========*/

.countdown_finished {
  display: none;
}

.countdown_bar {
  width: 100%;
  text-align: center;
  z-index: 6;
  animation: myanimation 14s infinite !important;
  padding: 10px 0;
}

@keyframes myanimation {
  0% {
    background-color: #ff0000;
  }

  25% {
    background-color: black;
  }

  50% {
    background-color: black;
  }

  75% {
    background-color: black;
  }

  100% {
    background-color: #ff0000;
  }
}

.countdown_content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 55px;
  margin-left: -21px;
}

.countdown_bar_text {
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  color: #fff;
}

.countdown_wrapper {
  color: #fff;
  display: flex;
  gap: 8px;
}

.countdown_wrapper li {
  text-transform: capitalize;
  font-size: 7.5px;
  font-weight: 400;
  line-height: 9.08px;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.countdown_wrapper li span {
  font-size: 15px;
  font-weight: 400;
  line-height: 18.52px;
}

.dots {
  margin-top: 3px;
  font-size: 15px !important;
}

.countdown_btn {
  text-decoration: underline;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  text-underline-offset: 2px;
}

@media screen and (max-width: 767px) {
  .countdown_content {
    gap: 22px !important;
    margin-left: 0;
  }

  .countdown_wrapper li {
    text-transform: capitalize;
    font-size: 6px;
    font-weight: 400;
    line-height: 7.26px;
  }

  .countdown_wrapper li span {
    font-size: 12px;
    font-weight: 400;
    line-height: 14.56px;
  }

  .dots {
    font-size: 12px !important;
  }
}
</style>
